<template>
  <!-- main -->
  <section class="main">
    <!-- Content -->
    <section class="wizard">
      <!-- Moon Loader -->
      <moon-loader
        v-bind:loading="isLoading"
        :color="loaderColor"
        :size="loaderSize"
        v-bind:loaderMessage="loaderMessage"
      ></moon-loader>
      <form-wizard ref="urlaWizard" :steps="steps">
        <component
        :is="currentSection.name" :source-section="currentSection.sourceSection"
        :currentPage="currentStep"
        :borrowerType="currentBorrowerType"
        :primaryBorrowerBaseInformation="primaryBorrowerBaseInformation"
        >
        </component>
      </form-wizard>
    </section>
    <pop-up v-bind:status="showPopUp" v-bind:statusMessage="popUpMessage"></pop-up>
  </section>
</template>

<script>
import { bus } from "@/main";
import VueGoodWizard from "@/components/elements/Wizard.vue";
import validationsMixin from "@/mixins/validationsMixin.js";
import inputMasksMixin from "@/mixins/inputMasksMixin.js";
import urlaMixin from "@/mixins/urlaMixin.js";
import MoonLoader from "@/components/elements/MoonLoader.vue";
import Section1 from "./Sections/Section1.vue";
import PopUp from "@/components/elements/popUp.vue";
// import Section2 from "./Sections/Section2.vue";
import Section3 from "./Sections/Section3.vue";
import Section4 from "./Sections/Section4.vue";
import Section5 from "./Sections/Section5.vue";
import Section7 from "./Sections/Section7.vue";
// import Section6 from "./Sections/Section6.vue";
import Section8 from "./Sections/Section8.vue";
import Disclaimer from "./Sections/Disclaimer.vue";

export default {
  name: "Urla",
  // props can be set from parent component
  props: ["customerId", "loanId", "sourceUrla"],
  // mixins used in this component
  mixins: [validationsMixin, urlaMixin, inputMasksMixin],
  // components used
  components: {
    "form-wizard": VueGoodWizard,
    "moon-loader": MoonLoader,
    "pop-up": PopUp,
    Section1,
    Section3,
    Section4,
    Section5,
    Section7,
    Section8,
    Disclaimer
  },
  data() {
    return {
      currentSection: {
        name: "Section1",
        sourceSection: null,
      },
      sectionsList: [],
      loaderSize: "100px",
      loaderColor: "#2ebfac",
      loaderMessage: "Saving",
      isLoading: false,
      isRetry: false,
      urla: null,
      numberOfBorrowers: 1,
      currentStep: 0,
      firstStep: 0,
      currentBorrowerType: "Primary-borrower",
      primaryBorrowerBaseInformation: {
        maritalStatus: "Unmarried",
        spouseFirstName: null,
        spouseLastName: null,
        spouseEmail: null,
        isSpouseIncludedOnTitle: null,
        isSpouseIncludedOnLoan: null,
        numberOfBorrowers: 1,
        otherBorrowers: [],
        typeOfCredit: "individual credit",
      },
      sectionMap: {
        "Section1": "section1BorrowerInformation",
        "Section3": "section3RealEstate",
        "Section4": "section4LoanAndPropertyInformation",
        "Section5": "section5Declarations",
        "Section7": "section7DemographicInformation",
        "Section8": "section8LoanOriginatorInformation",
        "Disclaimer": "section8LoanOriginatorInformation",
      },
      steps: [
        {
          label: "B",
          slot: "Section1",
          progressValue: 100,
        },
        {
          label: "",
          // exchanged section 3 & 4
          slot: "Section4",
          progressValue: 300,
        },
        {
          label: "B",
          // exchanged section 3 & 4
          slot: "Section3",
          progressValue: 400,
        },
        {
          label: "B",
          slot: "Section5",
          progressValue: 500,
        },
        {
          label: "B",
          slot: "Section7",
          progressValue: 700,
        },
        {
          label: "",
          slot: "Section8",
          progressValue: 800,
        },
        {
          label: "",
          slot: "Disclaimer",
          progressValue: 800,
          options: {
            nextDisabled: true, // control whether next is disabled or not
          },
        },
      ],
      showPopUp: false,
      popUpMessage: "",
    };
  },

  methods: {
    processAndSubmitUrla: async function(section) {
      //update the section in the urla
      this.updateSectionInUrla(section);
      if(await this.postUrlaSection()) {
        //load next section on the page
        let step=this.goToCurrentSection();
        //change step in wizard
        this.goToCurrentStep(step);
      } else {
        //if failed submit again
        if(this.isRetry) {
          this.processAndSubmitUrla(section);
        }
      }
    },
    throwErrorAlert: function(status) {
      const userResponse = window.confirm(`${status !== '' ? '(' + status + ') ' : ''}Something went Wrong.\nWould you like to submit again ?`);
      return userResponse;
    },
    updatePrimaryBorrowerBaseInformationInUrla: function(modifiedPrimaryBorrowerBaseInformation) {

      //load modified base information
      this.primaryBorrowerBaseInformation = JSON.parse(JSON.stringify(modifiedPrimaryBorrowerBaseInformation));

      //compare changes in data in section1 of urla with the base information and update them

      //NOTE: This condition ensures that no other sections are allowed to be filled unless Section-1(Primary Information is filled)
      if(this.urla.section1BorrowerInformation != undefined && this.urla.section1BorrowerInformation != null) {

        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          numberOfBorrowers=this.primaryBorrowerBaseInformation.numberOfBorrowers;

        //create spouse object if it is null
        if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse === null) 
        {
          this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse = {};
        }

        //then add spouse details into urla
        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          spouse.firstName=this.primaryBorrowerBaseInformation.spouseFirstName;
        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          spouse.lastName=this.primaryBorrowerBaseInformation.spouseLastName;
        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          spouse.emailAddress=this.primaryBorrowerBaseInformation.spouseEmail;
        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          otherBorrowers=[...this.primaryBorrowerBaseInformation.otherBorrowers];
        this.urla.section1BorrowerInformation.part1aPersonalInformation.
          typeOfCredit=this.primaryBorrowerBaseInformation.typeOfCredit;

        //check if co-borrowers are added or removed
        if(this.urla.section1BorrowerInformation.part1aPersonalInformation.
        spouse.isIncludedOnLoan !== this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan) {

          if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse
            .isIncludedOnLoan == true && 
            (this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan == null ||
            !this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan)) {
              //remove co-borrowers
              this.showPopUp=true;
              this.popUpMessage="Removing Co-borrower Pages from the Application Form ..";
              new Promise(() => {
                setTimeout(() => {
                  this.showPopUp=false;
                  this.popUpMessage="";
                },2500)
              });
              this.updateCoBorrowersForm("remove");
              //unsetting co-borrower info in urla
              this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section1BorrowerInformation=null;
              this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section3RealEstate=null;
              this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section5Declarations=null;
              this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section7DemographicInformation=null;
          } else if((
            this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse
            .isIncludedOnLoan == false || this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse
            .isIncludedOnLoan == null) && 
            this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan == true
          ) {
            //add co-borrowers
            this.showPopUp=true;
            this.popUpMessage="Adding Pages to the Application Form ..";
            new Promise(() => {
              setTimeout(() => {
                this.showPopUp=false;
                this.popUpMessage="";
              },2500)
            });
            this.updateCoBorrowersForm("add");
          }
        }

        //update co-borrower or spouse statuses
        this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse
          .isIncludedOnLoan=this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan;
        this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse
          .isIncludedOnTitle=this.primaryBorrowerBaseInformation.isSpouseIncludedOnTitle;
      }

    },
    pageReloadAlert: function(event) {
      // confirm to reload
      var reloadPage = window.confirm("");

      // reload if user selects to reload
      if (reloadPage) this.$router.push({ name: "urla" });
      else event.preventDefault();

      // Chrome requires returnValue to be set
      event.returnValue = "";
    },

    calculateStepValue: function(progressValue) {
      let offset = Math.floor(progressValue / 100);
      let progressFactor = Math.floor((progressValue % 100)/10);
      switch (offset) {
        case 0:
          offset = 0;
          progressFactor = 0;
          break;
        case 1:
          if(progressFactor == 0 ) {
            offset = 0;
          }
          break;
        case 3:
          offset = 1;
          break;
        case 4:
          offset = 2;
          break;
        case 5:
          offset = 3;
          break;
        case 7:
          offset = 4;
          break;
        case 8:
          offset = 5;
          break;
        default:
          break;
      }
      let stepValue = 4 * (progressFactor) + offset;
      return stepValue;
    },

    goToCurrentSection: function() {
      // route to urla submitted page if loanApplicationProgress >= 800
      if (this.urla.loanApplicationProgress >= 800 && (this.currentStep % 4 != 1)) {
        //coming from disclaimer
        this.$router.push({
          name: "urla-submitted",
           params: {
              loanPurpose: this.urla.section4LoanAndPropertyInformation
                .part4aLoanInformation.loanPurpose,
            },
        });

        // return from method
        return -1;
      } else if(this.urla.loanApplicationProgress >= 800) {
        //go to disclaimer
        this.loadSectionFromUrla(this.currentStep + 1);
        return this.currentStep + 1;
      }
      
      this.currentStep = this.calculateStepValue(this.urla.loanApplicationProgress);
      //load component (if loan progress is 0 refer to same section or go to next section
      this.urla.loanApplicationProgress == 0 ? this.loadSectionFromUrla(this.currentStep) : this.loadSectionFromUrla(this.currentStep + 1);
      // navigate to current step
      return this.urla.loanApplicationProgress == 0 ? this.currentStep : this.currentStep + 1; 
    },

    //this method switches to corresponding section on the page
    loadSectionFromUrla: function(stepIndex) {
      this.currentSection.name = this.steps[stepIndex].slot;
      if (this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan) {
        //handle data across sections if co-borrower exists by reusing sections with similar information
        if(this.currentSection.name === "Section8" ||
            this.currentSection.name === "Disclaimer" ||
            this.currentSection.name === "Section4") {
          this.currentBorrowerType = "Primary-borrower";
          this.currentSection.sourceSection = this.urla[this.sectionMap[this.currentSection.name]] != undefined ? JSON.parse(JSON.stringify(this.urla[this.sectionMap[this.currentSection.name]])) : null;
        } else {
          let urlaIndex = Math.floor((stepIndex - 1) / 4) - 1;
          if(urlaIndex < 0) {
            this.currentBorrowerType = "Primary-borrower";
            this.currentSection.sourceSection = this.urla[this.sectionMap[this.currentSection.name]] != undefined ? JSON.parse(JSON.stringify(this.urla[this.sectionMap[this.currentSection.name]])) : null;
          } else {
            this.currentBorrowerType = "Co-borrower";
            this.currentSection.sourceSection = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[this.sectionMap[this.currentSection.name]] != undefined ? JSON.parse(JSON.stringify(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[this.sectionMap[this.currentSection.name]])) : null;
          }
        }         
      } else {
        // if no co-borrower exist
        this.currentBorrowerType = "Primary-borrower";
        this.currentSection.sourceSection = this.urla[this.sectionMap[this.currentSection.name]] != undefined ? JSON.parse(JSON.stringify(this.urla[this.sectionMap[this.currentSection.name]])) : null;
      }
    },

    goToCurrentStep(step) {
      //move the step arrow to current position
      if(step > 0)  {
        this.$refs.urlaWizard.goTo(step);
        this.currentStep++;
      }
    },

    //populate section data into corresponding properties in the urla
    updateSectionInUrla: function(section) {
      if (this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan) {    
        // if co-borrower is present
        if(section.sectionName === "section8LoanOriginatorInformation" ||
           section.sectionName === "section4LoanAndPropertyInformation") {
          this.urla[section.sectionName] = section;
        } else {
          let urlaIndex = Math.floor((this.currentStep - 1) / 4) - 1;
          if(urlaIndex < 0) {
            //section belongs to primary borrower
            this.urla[section.sectionName] = section;
          } else {     
            //update urla for co borrowers
            if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[section.sectionName] == undefined ||
            this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[section.sectionName] == null
            ) {
              this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[section.sectionName] = {};
            }
            this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse[section.sectionName] = section;
          }
        }
      } else {
        this.urla[section.sectionName] = section;
      }

      //update application progress in urla
      this.urla.loanApplicationProgress = section.loanApplicationProgress;
    },

    async postUrlaSection() {
      //const ERROR_MESSAGE = "Unexpected Error";
      // set moon-loader
      this.isLoading = true;

      // set updatedByApp as FRONTEND
      this.urla.updatedByApp = "FRONTEND";

      let loanApplicationProgress = this.urla.loanApplicationProgress;

      // post URLA using REST API
      let response = await this.callUrlasAPIAndUpdateUrla(
        this.customerId,
        this.loanId,
        this.urla
      ).catch(() => {
        this.isLoading = false;
        this.isRetry = this.throwErrorAlert();
        return false;
      });
      this.isLoading = false;
      if (response.status !== 200 || response.data === undefined) {
        this.isRetry = this.throwErrorAlert(response.status);
        return false;
      }
      this.urla = response.data;

      //set appropriate application progress value if co-borrowers are there
      this.urla.loanApplicationProgress = loanApplicationProgress;
      return true;
    },

    setUpEventListeners: function() {
      // 1. Event listener to submit current section
      bus.$on("postUrla", async (section) => {
        // clone section
        const sectionCopy = JSON.parse(JSON.stringify(section));
        this.processAndSubmitUrla(sectionCopy);
      });

      // 2. Event listener to go back to previous section
      bus.$on("goBack", (currentPage) => {
        //update component
        this.currentStep = currentPage - 1;
        // load section of previous page before going there
        this.loadSectionFromUrla(currentPage - 1);
        // navigate to Previous page
        this.$refs.urlaWizard.goTo(currentPage - 1); 
      });
 
      // 3. Event listener to go to next section
      bus.$on("nextPage", (section) => {
        // navigate to next step
        const sectionCopy = JSON.parse(JSON.stringify(section));
        //copy section into urla
        this.urla.section8LoanOriginatorInformation = sectionCopy;
        //load next section
        let nextStep = this.currentStep + 1;
        this.loadSectionFromUrla(nextStep);
        //change step in wizard
        this.goToCurrentStep(nextStep);
      });

      //4. Update primary information in the current component data
      bus.$on("updatePrimaryInformation", (primaryBorrowerBaseInformation) => {
        this.updatePrimaryBorrowerBaseInformationInUrla(primaryBorrowerBaseInformation);
      });

      //5. Event listener to show pop-up when creating sections for co-borrower
      bus.$on("displayPopUpOfCreatingNewSections", () => {
        this.showPopUp=true;
        this.popUpMessage="Updating Form for Co-Borrower..";
        new Promise(() => {
          setTimeout(() => {
            this.showPopUp=false;
            this.popUpMessage="";
          },2500)
        });
      });

      //6. Event listener to page reload current page
      window.addEventListener('beforeunload', this.pageReloadAlert);
    },

    updateCoBorrowersForm: function(mode) {
      if(mode === 'add') {
        this.addStepsForCoBorrowersInTheForm(1);
      } else if (mode === 'remove') {
        this.removeStepsOfCoBorrowersInTheForm(1);
      }
    },

    removeStepsOfCoBorrowersInTheForm(numberOfBorrowersTobeRemoved) {
      for(let i= this.steps.length - 3; i>(4 * numberOfBorrowersTobeRemoved); i--) {
        this.steps.splice(i, 1);
      }
    },

    addStepsForCoBorrowersInTheForm(numberOfBorrowersTobeAdded) {
      for(let i=1; i<=numberOfBorrowersTobeAdded ; i++) {
        let pageStart = (4 * i) + 1;
        this.steps.splice(pageStart, 0, {
          label: "C",
          slot: `Section1`,
          progressValue: 100 + (i * 10),
        });

        this.steps.splice(pageStart + 1, 0, {
          label: "C",
          slot: `Section3`,
          progressValue: 400 + (i * 10),
        });

        this.steps.splice(pageStart + 2, 0, {
          label: "C",
          slot: `Section5`,
          progressValue: 500 + (i * 10),
        });

        this.steps.splice(pageStart + 3, 0, {
          label: "C",
          slot: `Section7`,
          progressValue: 700 + (i * 10),
        });
      }
    }
  },

  

  mounted: function() {
    //go to steps
    this.goToCurrentStep(this.firstStep);
    // set up event listeners for bus
    this.setUpEventListeners();
  },

  created: function() {
    // store a copy of urla received as prop
    this.urla = JSON.parse(JSON.stringify(this.sourceUrla));

    //check if the application is already filled partially then save primary borrower base information
    if(this.urla.section1BorrowerInformation != null) {

      //save number of borrowers in the base
      this.primaryBorrowerBaseInformation.maritalStatus = this.urla.section1BorrowerInformation.part1aPersonalInformation.maritalStatus;
      this.primaryBorrowerBaseInformation.numberOfBorrowers = this.urla.section1BorrowerInformation.part1aPersonalInformation.numberOfBorrowers == null ? 1 :
      this.urla.section1BorrowerInformation.part1aPersonalInformation.numberOfBorrowers;

      this.primaryBorrowerBaseInformation.otherBorrowers = this.urla.section1BorrowerInformation.part1aPersonalInformation.otherBorrowers === null ? [] :
      [...this.urla.section1BorrowerInformation.part1aPersonalInformation.otherBorrowers];
      this.primaryBorrowerBaseInformation.typeOfCredit = this.urla.section1BorrowerInformation.part1aPersonalInformation.typeOfCredit;

      //check if spouse details are already filled
      if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse != null) {

        //check if co-borrower details are filled and then extract spouse information from there
        if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section1BorrowerInformation != null &&
        this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.section1BorrowerInformation.part1aPersonalInformation != undefined
        ) {

          this.primaryBorrowerBaseInformation.spouseFirstName = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.
                                                                    section1BorrowerInformation.part1aPersonalInformation.firstName;
          this.primaryBorrowerBaseInformation.spouseLastName = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.
                                                                    section1BorrowerInformation.part1aPersonalInformation.lastName;
          this.primaryBorrowerBaseInformation.spouseEmail = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.
                                                                    section1BorrowerInformation.part1aPersonalInformation.emailAddress;

        } else {
          // else extract them from section1
          this.primaryBorrowerBaseInformation.spouseFirstName = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.firstName;
          this.primaryBorrowerBaseInformation.spouseLastName = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.lastName;
          this.primaryBorrowerBaseInformation.spouseEmail = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.emailAddress;
        }

        //update pages for co-borrower if co-borrower exists
        if(this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.isIncludedOnLoan != null &&
          this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.isIncludedOnLoan != undefined &&
          this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.isIncludedOnLoan) {

          //generate pages for where co-borrower has filled
          this.updateCoBorrowersForm("add");
        } 

        this.primaryBorrowerBaseInformation.isSpouseIncludedOnLoan = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.isIncludedOnLoan;
        this.primaryBorrowerBaseInformation.isSpouseIncludedOnTitle = this.urla.section1BorrowerInformation.part1aPersonalInformation.spouse.isIncludedOnTitle;
      }
      
    }
    
    // go to current section
    this.firstStep = this.goToCurrentSection();
  },

  beforeDestroy: function() {
    // remove event listeners
    // 1. Event listener to submit current section
    bus.$off("postUrla");
    // 2. Event listener to go back to previous section
    bus.$off("goBack");
    // 3. Event listener for reload
    window.removeEventListener("beforeunload",this.pageReloadAlert);
    // 4. Event listener to go to next section
    bus.$off("nextPage");
    // 5. Update primary information in the current component data
    bus.$off("updatePrimaryInformation");
    //6. Event listener to show pop-up when creating additional sections
    bus.$off("displayPopUpOfCreatingNewSections");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* styles for wizard */
.wizard {
  margin-top: 10px;
  padding-top: 0 !important;
}

.center-align-text {
  text-align: center;
}

.urla-section-footer {
  width: 100%;
  margin:0%;
  padding: 0 0 1em 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  caret-color: transparent;
}

/* styles for section description */
.urla-section-description {
  margin: auto;
  margin-bottom: 1rem;
  font-size: 18px;
}

.section-description {
  margin: 0 0 1.5rem 32px;
  font-size: 18px;
}

/* styles for form inside wizard section */
.urla-section form {
  margin: auto 2rem;
}

/* style for Required Asterisk */
.urla-section .instruction {
  margin: auto 2rem;
}

/* border style for left section on mobile devices */
@media screen and (max-width: 800px) {
  .urla-left-section {
    border-right: none !important;
  }
}

@media screen and (max-width: 480px) {
  .urla-left-section {
    border-right: none !important;
  }

  .urla-middle-section {
    border-right: none !important;
    border-left: none !important;
  }

  .urla-section form {
    margin: 0;
  }

  /* style for Required Asterisk */
  .urla-section .instruction {
    margin: 0;
  }
}

@media screen and (max-width: 360px) {
  .urla-left-section {
    border-right: none !important;
  }

  .urla-middle-section {
    border-right: none !important;
    border-left: none !important;
  }

  .urla-section form {
    margin: 0;
  }

  /* style for Required Asterisk */
  .urla-section .instruction {
    margin: 0;
  }
}

.urla-section .required,
.urla-section .instruction,
.urla-section .error {
  text-decoration: none;
  /*color: #bf4d2e;*/
  color: #ff5049;
  padding: 0;
}

/* font style for h5 heading */
.urla-section h5 {
  font-size: 16px;
  font-weight: bold;
}

/* font styles for form elements */
.urla-section form p,
.urla-section form legend,
.urla-section form label {
  font: inherit;
  font-size: 16px;
  font-style: normal;
  text-transform: none;
  margin: 0;
  padding-bottom: 1.25%;
  color: #464646;
}

/* border style for left section of form */
.urla-left-section {
  border-right: dashed #2ebfac 1px;
  margin-bottom: 0;
}

.urla-right-section {
  margin-bottom: 0;
}

.urla-middle-section {
  border-right: dashed #2ebfac 1px;
  border-left: dashed #2ebfac 1px;
}

/* font styles for form elements */
.urla-section form label {
  font-weight: bold;
}

input[type="radio"] + label::before {
  height: 1.25em;
  width: 1.25em;
  line-height: 1.2em;
}

/* style for horizontal break */
.urla-break {
  margin: 0.75rem auto;
}

/* styles for extra small labels and inputs */
.x-small-label {
  width: 75px !important;
  margin-right: 2%;
  box-sizing: border-box;
}

.x-small-input {
  width: 60px !important;
  /* margin-right: 2%;*/
  box-sizing: border-box;
}

/* styles for small labels and inputs */
.small-label {
  width: 125px !important;
  margin-right: 2%;
  box-sizing: border-box;
}

.small-input {
  width: 125px !important;
  box-sizing: border-box;
}

/* styles for medium labels and inputs */
.medium-label {
  width: 200px !important;
  margin-right: 2%;
  box-sizing: border-box;
}

.medium-input {
  width: 200px !important;
  box-sizing: border-box;
}

/* styles for large labels and inputs */
.large-label {
  width: 400px !important;
  margin-right: 2%;
  box-sizing: border-box;
}

.large-input {
  width: 400px !important;
  box-sizing: border-box;
}

/* style for input and labels */
.urla-section input,
.urla-section label,
.urla-section select,
.urla-section .empty-label {
  display: inline-block;
  width: 250px;
  box-sizing: border-box;
}

/* style for long input and labels (appx. 1/3 of width)*/
.urla-section input.long,
.urla-section label.long,
.urla-section select.long,
.urla-section .empty-label.long {
  width: 300px !important;
}

/* style for input and labels (appx. 1/2 of width)*/
.urla-section input.extra-long,
.urla-section label.extra-long,
.urla-section select.extra-long,
.urla-section .empty-label.extra-long {
  width: 500px !important;
}

/* hide arrows for input[type=number] */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

/* hidden label */
.hidden-label {
  display: none !important;
}

/* bold font */
.font-weight-bold {
  font-weight: bold !important;
}

/* normal font */
.font-weight-normal {
  font-weight: normal !important;
}

/* italic font */
.font-style-italic {
  font-style: italic !important;
}

/* width for list elements in radio */
.urla-section input[type="radio"] {
  width: auto;
}

.urla-radio-label {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  /* line-height: 2.75rem !important; */
}

/* style for inline radio buttons*/
.radio-inline li,
.checkbox-inline li {
  display: inline;
}

.checkbox-inline ul {
  padding-left: 0;
}

/* width for list elements in checkbox */
.urla-section input[type="checkbox"] {
  width: auto;
}

/* style for list elements in radio/select/checkbox */
.urla-section fieldset ul {
  margin: 0;
}

.urla-section fieldset li {
  /* display: inline; */
  list-style-type: none;
  padding: 0;
}

/* hide arrows for date in chrome browser */
input[type="date"]::-webkit-inner-spin-button {
  display: none;
  -webkit-appearance: none;
}

/* Enter/Leave & List Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: height 0.5s ease, opacity 0.3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  height: 0px;
}

/* v-for transitions for list of otherBorrowers */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease, height 0.5s ease, opacity 0.3s ease;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: translateY(30px); */
}
.inline-list {
  display: inline;
}

/* Styles for back and next buttons */
.clearfix::after {
  display: block;
  content: "";
  clear: both;
}
.clearfix {
  font-size: 16px;
}

/* style for box in transition-group list */
.urla-section .box {
  margin-bottom: 1rem;
}

/* styles for table */
.input-table {
  margin-bottom: 1rem;
}

.row .input-table {
  margin: auto 2rem;
}

/* style for rows in table */
.input-table tr {
  background: none !important;
}

.input-table tr:last-child {
  border-bottom: none;
}

.table-heading th {
  font-size: 16px;
}

.medium-column {
  width: 270px;
}

.small-column {
  width: 230px;
}

.x-small-column {
  width: 70px;
  padding: 0;
}

.remove-button,
.inner-remove-button {
  /* float: right; */
  background: none;
  border: none !important;
  padding: 0;
  cursor: pointer;
  /*display: none;*/
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  height: 22px;
  color: #ff5049 !important;
}

.remove-button:hover,
.inner-remove-button:hover {
  color: #f9020e !important;
}

.remove-button:focus,
.inner-remove-button:hover {
  outline: none;
}

.add-button {
  font-size: 14px;
  color: #2ebfac !important;
}

.add-button:active,
.remove-button:active {
  transform: translateY(2px);
}

.left-indent {
  padding-left: 2rem;
}

/* styles for vue-date-pick*/
.date-pick .vdpInnerWrap table {
  margin: 0;
  border-collapse: unset;
}

.date-pick table tbody tr {
  background-color: inherit;
}

.vdpPeriodControl > button {
  margin: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
}

button.vdpClearInput {
  border: none !important;
}

.vdpClearInput::before {
  color: grey;
  background-color: #f7f7f7;
  margin: 0 0 0 -0.5rem;
  border: 1px solid grey;
}

.vdpHeader button,
.vdpPeriodControl button {
  border: none !important;
}

.date-pick .vdpCell.today {
  color: #2ebfac;
}

.date-pick .vdpArrowPrev:after {
  border-right-color: #2ebfac;
}

.date-pick .vdpArrowNext:after {
  border-left-color: #2ebfac;
}

.date-pick .vdpCell.selectable:hover .vdpCellContent,
.vdpCell.selected .vdpCellContent {
  background: #2ebfac;
}

.urla-section .date-pick.medium-input input {
  width: 200px !important;
  box-sizing: border-box;
}

.urla-section .date-pick.small-input input {
  width: 125px !important;
  box-sizing: border-box;
  padding-right: 25px;
}
</style>
